var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionClearAllFields({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.70711 7.29289C1.31658 6.90237 0.683417 6.90237 0.292893 7.29289C-0.0976311 7.68342 -0.0976311 8.31658 0.292893 8.70711L3.58579 12L0.292893 15.2929C-0.0976311 15.6834 -0.0976311 16.3166 0.292893 16.7071C0.683417 17.0976 1.31658 17.0976 1.70711 16.7071L5 13.4142L8.29289 16.7071C8.68342 17.0976 9.31658 17.0976 9.70711 16.7071C10.0976 16.3166 10.0976 15.6834 9.70711 15.2929L6.41421 12L9.70711 8.70711C10.0976 8.31658 10.0976 7.68342 9.70711 7.29289C9.31658 6.90237 8.68342 6.90237 8.29289 7.29289L5 10.5858L1.70711 7.29289Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 7H14C13.4477 7 13 7.44772 13 8C13 8.55228 13.4477 9 14 9H23C23.5523 9 24 8.55228 24 8C24 7.44772 23.5523 7 23 7Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 12C13 11.4477 13.4477 11 14 11H20C20.5523 11 21 11.4477 21 12C21 12.5523 20.5523 13 20 13H14C13.4477 13 13 12.5523 13 12Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 16C13 15.4477 13.4477 15 14 15H17C17.5523 15 18 15.4477 18 16C18 16.5523 17.5523 17 17 17H14C13.4477 17 13 16.5523 13 16Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionClearAllFields);
export default __webpack_public_path__ + "static/media/ic_action_clear_all_fields.80fdcfc83df6dee049f7e70637cfac5e.svg";
export { ForwardRef as ReactComponent };